/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_BadgeInputs */

const en_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*NEW*`)
};

const fr_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*NOUVEAU*`)
};

const de_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*NEU*`)
};

const it_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*NUOVO*`)
};

const ru_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*НОВЫЙ*`)
};

const es_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*NUEVO*`)
};

const zh_cn2_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*新的*`)
};

const ja_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*新しい*`)
};

const hi_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*नया*`)
};

const pt_pt2_new_badge = /** @type {(inputs: New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`*NOVO*`)
};

/**
* | output |
* | --- |
* | "*NEW*" |
*
* @param {New_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_badge = /** @type {((inputs?: New_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_badge(inputs)
	if (locale === "de") return de_new_badge(inputs)
	if (locale === "it") return it_new_badge(inputs)
	if (locale === "ru") return ru_new_badge(inputs)
	if (locale === "es") return es_new_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_new_badge(inputs)
	if (locale === "ja") return ja_new_badge(inputs)
	if (locale === "hi") return hi_new_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_new_badge(inputs)
	return en_new_badge(inputs)
});